import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareUploadFileBlockData from '../../../Models/Content/SelfCareUploadFileBlockData';
import SelfCareUploadFile from './SelfCareUploadFile.js'
export default class SelfCareUploadFileBlock extends EpiComponent<SelfCareUploadFileBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (  
          <SelfCareUploadFile iContent={this.props.data}/>
          
      )
    }
}